import PropTypes from 'prop-types';
import React from 'react';

const PrefillCard = ({ children, testId, title }) => (
  <div className="vads-u-margin-y--3" data-testid={testId}>
    <va-card>
      <h2 className="vads-u-margin-top--0 vads-u-margin-bottom--1 vads-u-font-size--h3">
        {title}
      </h2>
      {children}
    </va-card>
  </div>
);

PrefillCard.propTypes = {
  children: PropTypes.node,
  testId: PropTypes.string,
  title: PropTypes.string,
};

export default PrefillCard;
